import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44b8987c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "article_menu" };
const _hoisted_2 = { class: "article_menu__navigation" };
const _hoisted_3 = { class: "container article_menu__navigation--tabs" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", { class: "mobile" }, "Sort by:", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "article_menu__navigation--shadow" }, null, -1));
const _hoisted_6 = { class: "article-background py-5" };
const _hoisted_7 = { class: "container" };
const _hoisted_8 = { class: "article_menu__content" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
    key: 1,
    class: "load-more-wrapper"
};
import { ref } from 'vue';
import axios from 'axios';
import InfiniteLoading from "v3-infinite-loading";
export default /*#__PURE__*/ _defineComponent({
    __name: 'article_list',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const articles = ref([]);
        const page = ref(1);
        const showLoadMoreButton = ref(false); // Initially show the "More" button
        const loadMoreCount = ref(4);
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 1023);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 1023;
        });
        const fetchArticles = async ($state) => {
            const category = props.d.current_tab_selected !== 'latest' ? props.d.current_tab_selected : null;
            try {
                const response = await axios.get('/api/articles', {
                    params: {
                        category,
                        page: page.value, // Pagination, fetching only the first page
                    },
                });
                // Add the articles to the articles array
                for (const article of response.data.data) {
                    articles.value.push(article);
                }
                page.value++;
                showLoadMoreButton.value = articles.value.length == loadMoreCount.value;
            }
            catch (error) {
                // console.log(error);
                $state.error();
            }
        };
        return (_ctx, _cache) => {
            const _component_article_item = _resolveComponent("article-item");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("a", {
                            href: "/articles",
                            class: _normalizeClass(["article_menu__navigation--tab no-style", { 'article_menu__navigation--tab__active': __props.d.current_tab_selected == 'latest' }])
                        }, " Latest ", 2),
                        _createElementVNode("a", {
                            href: "/articles/news",
                            class: _normalizeClass(["article_menu__navigation--tab no-style", { 'article_menu__navigation--tab__active': __props.d.current_tab_selected == 'news' }])
                        }, " News ", 2),
                        _createElementVNode("a", {
                            href: "/articles/insights",
                            class: _normalizeClass(["article_menu__navigation--tab no-style", { 'article_menu__navigation--tab__active': __props.d.current_tab_selected == 'insights' }])
                        }, " Insights ", 2)
                    ])
                ]),
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "py-5",
                                    key: index
                                }, [
                                    _createVNode(_component_article_item, {
                                        d: { align: index % 2 === 0 ? 'right' : 'left', article: article }
                                    }, null, 8, ["d"])
                                ]));
                            }), 128)),
                            (!showLoadMoreButton.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createVNode(_unref(InfiniteLoading), {
                                        distance: 1000,
                                        onInfinite: fetchArticles
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            (showLoadMoreButton.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("a", {
                                        class: "load-more-button",
                                        onClick: fetchArticles
                                    }, "More")
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
